import React from "react";
import { Link } from "react-router-dom";
import { usePermissions } from "../../../../utils/permissions";

const secciones = [
  {
    key: "menus",
    label: "Menú",
    descripcion: "Reordena y organiza los módulos del sidebar arrastrando.",
    icon: "bi-layout-sidebar",
    to: "/dashboard/configuracion/menus",
    permiso: "configuracion",
  },
  {
    key: "bonificaciones",
    label: "Bonificaciones",
    descripcion: "Configura el monto por defecto y el período de vencimiento de los bonos.",
    icon: "bi-coin",
    to: "/dashboard/configuracion/bonificaciones",
    permiso: "configuracion.bonificaciones",
  },
  {
    key: "sistema",
    label: "Sistema",
    descripcion: "Duración de sesión y otros parámetros generales de la plataforma.",
    icon: "bi-shield-lock",
    to: "/dashboard/configuracion/sistema",
    permiso: "configuracion",
  },
  {
    key: "campus",
    label: "Campus Ademy",
    descripcion: "Ponderación de notas, política de aprobación y parámetros del portal estudiantil.",
    icon: "bi-mortarboard",
    to: "/dashboard/configuracion/campus",
    permiso: "configuracion",
  },
  {
    key: "documentos",
    label: "Documentos",
    descripcion: "Activa, desactiva o agrega los tipos de documento que se piden a los estudiantes.",
    icon: "bi-file-earmark-text",
    to: "/dashboard/configuracion/documentos",
    permiso: "configuracion",
  },
  {
    key: "entregables",
    label: "Entregables",
    descripcion: "Administra el catalogo de articulos y documentos entregables, y en que cursos aplica cada uno.",
    icon: "bi-box-seam",
    to: "/dashboard/configuracion/entregables",
    permiso: "configuracion",
  },
];

export default function ConfiguracionIndex() {
  const { hasPermission } = usePermissions();
  const visibles = secciones.filter((s) => hasPermission(s.permiso));

  if (!visibles.length) return null;

  return (
    <section className="management-page management-theme-teal configuracion-wrapper">
      <div className="container-fluid">
        <div className="management-card management-header mb-4">
          <div className="dashboard-eyebrow">Configuración</div>
          <h5 className="mb-1">Configuración del sistema</h5>
          <p className="text-muted mb-0">Selecciona una sección para ajustar los parámetros.</p>
        </div>

        <div className="row g-3">
          {visibles.map((s) => (
            <div className="col-12 col-sm-6 col-lg-4" key={s.key}>
              <Link to={s.to} className="text-decoration-none">
                <div className="card h-100 border-0 shadow-sm config-card">
                  <div className="card-body d-flex gap-3 align-items-start p-4">
                    <div className="config-card-icon">
                      <i className={`bi ${s.icon}`}></i>
                    </div>
                    <div>
                      <h6 className="mb-1 fw-semibold">{s.label}</h6>
                      <p className="text-muted mb-0 small">{s.descripcion}</p>
                    </div>
                    <i className="bi bi-chevron-right ms-auto text-muted align-self-center"></i>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
